'use strict';

customerZone.service('isoCountriesService', ['utils', function(utils){
    var self = this;
    var countryKeys = {};

    var isoCodes = ['ad', 'ae', 'af', 'ag', 'ai', 'al', 'am', 'ao', 'ar', 'at', 'au', 'aw', 'az', 'ba', 'bb', 'bd',
        'be', 'bf', 'bg', 'bh', 'bi', 'bj', 'bm', 'bn', 'br', 'bs', 'bt', 'bw', 'by', 'bz', 'ca', 'cc', 'cf', 'ch',
        'ci', 'ck', 'cl', 'cm', 'cn', 'co', 'cr', 'cu', 'cv', 'cw', 'cx', 'cy', 'cz', 'de', 'dj', 'dk', 'dm', 'dz',
        'ec', 'ee', 'eg', 'er', 'es', 'et', 'fi', 'fj', 'fk', 'fo', 'fr', 'ga', 'gb', 'gd', 'ge', 'gg', 'gh', 'gi',
        'gl', 'gm', 'gn', 'gp', 'gq', 'gr', 'gt', 'gu', 'gw', 'gy', 'hk', 'hn', 'hr', 'ht', 'hu', 'id', 'ie', 'il',
        'in', 'iq', 'ir', 'is', 'it', 'je', 'jm', 'jo', 'jp', 'ke', 'kg', 'kh', 'ki', 'kn', 'kp', 'kr', 'kw', 'ky',
        'kz', 'la', 'lb', 'lc', 'li', 'lk', 'lr', 'ls', 'lt', 'lu', 'lv', 'ly', 'ma', 'mc', 'md', 'me', 'mg', 'mh',
        'mk', 'ml', 'mm', 'mn', 'mo', 'mq', 'mr', 'ms', 'mt', 'mu', 'mv', 'mw', 'mx', 'my', 'mz', 'na', 'nc', 'ne',
        'nf', 'ng', 'ni', 'nl', 'no', 'np', 'nr', 'nu', 'nz', 'om', 'pa', 'pe', 'pf', 'pg', 'ph', 'pk', 'pl', 'pm',
        'pr', 'pt', 'pw', 'py', 'qa', 're', 'ro', 'rs', 'ru', 'rw', 'sa', 'sb', 'sc', 'se', 'sg', 'si', 'sl', 'sm',
        'sn', 'so', 'sr', 'st', 'sv', 'sy', 'sz', 'tc', 'td', 'tg', 'th', 'tj', 'tl', 'tm', 'tn', 'to', 'tr', 'tt',
        'tv', 'tw', 'tz', 'ua', 'us', 'uy', 'uz', 'va', 'vc', 've', 'vg', 'vn', 'vu', 'wf', 'xx', 'ye', 'za', 'zm',
        'zw'];

    (function(){
        isoCodes.forEach(function(item){
            countryKeys[utils.translate('country_' + item)] = item;
        });
        return countryKeys;
    }());

    self.isoForCountry = function(country){
        return countryKeys[country];
    };

    self.countryForIso = function(iso){
        return utils.translate('country_'+iso);
    };
}]);
